import { useEffect } from "react"

function Traditions() {
  useEffect(() => {
    document.title ="Traditions";
  });

  return (
    <div class="content">
      <div class="w-container">
        <div class="page-head">
          <div class="page-title">
            <h1 class="h1">
              Our Traditions
            </h1>
          </div>
          <div class="flex-vert">
            <div class="sub-hrule"></div>
            <p class="paragraph-center sub">
              It’s easy to say that Wiess is the best college (because it’s true), but you’re probably wondering 
where this superiority came from. As one of the original residential colleges, we have developed an impressively 
rich set of traditions over the last 50-plus years. It may seem like there’s a lot here to keep track of, but don’t worry! 
Every Wiessman has managed to understand and love these traditions—you will surely be able to do the same.
            </p>
          </div>
        </div>
        <div class="flex-vert">
          <h3 class="h3">O-Week</h3>
          <div class="sub-hrule"></div>
          <div class="gallery">
            <img src="/images/about/oweek.jpg" alt="O-Week" />
            <img src="/images/about/oweek2.jpg" alt="O-Week" />
          </div>
          <p class="paragraph-center sub">
             You may have some expectations for your college 
orientation, but they probably aren’t as high as they 
should be. At Rice, Orientation Week (which will almost 
always be referred to as O-Week) provides you with a 
foundation for everything you need to know to succeed 
at Rice—along with an introduction to Wiess, your home 
for the next four years. As soon as you arrive on campus, 
you’ll be greeted by our fantastic advising team. The team 
is made up of some of the best students that Rice has 
to offer, each specially selected and trained to give you 
the smoothest possible transition into college. Shortly 
afterwards, you’ll be introduced to your O-Week group, 
a small group of new students with diverse backgrounds 
and interests. Together, you’ll journey through an exciting 
week that lingers in students’ memories long after they 
graduate.
          </p>
          <p class="paragraph-center sub">
              Half of O-Week is dedicated to academic advising. As 
the first day of classes approaches, you may be growing 
nervous that you haven’t decided a course schedule yet—
 but don’t worry. We will have more academic resources 
than you could ever imagine at O-Week. Peer Academic 
Advisors, Divisional Advisors, and individual departments 
will give you plenty of guidance, while the rest of the 
advising team will help you to understand what these 
resources are and how to use them effectively.
          </p>
          <p class="paragraph-center sub">
             While academics may be  one of the main aspects of Rice, 
college life is more than just classes. The other half of 
O-Week is devoted to student life within Wiess and Rice 
as a whole. We will discuss extracurricular involvement, 
health and wellbeing, diversity, safety, the alcohol policy, 
and the academic Honor Code. In addition to our advising 
team, you’ll also be introduced to the Wiess Core Team: 
the Magisters, Resident Associates (RAs), and College 
Coordinator, who will be adult resources throughout your 
Wiess tenure. Together, our priority is to provide you with 
an O-Week that leaves you well-equipped and confident 
in tackling your years here at Rice.
          </p>
          <h3 class="h3" style={{ paddingTop: "50px" }}>College Night</h3>
          <div class="sub-hrule"></div>
          <div class="gallery">
            <img src="/images/about/collegenightfall.jpg" alt="Fall College Night" />
            <img src="/images/about/collegenightspring.jpg" alt="Spring College Night" />
          </div>
          <p class="paragraph-center sub">
              College Night is an event held by each residential
 college once per semester, typically on Fridays. They 
are characterized by fun in the Acabowl all afternoon, 
good food, a night full of celebrations, and cute pictures 
in matching college t-shirts. Each College Night has its 
own new and exciting theme, which in recent years have 
stemmed from The Wolf of Wiess Street to Piggy 500. It is one of the highlights of the 
semester, so stay tuned for a theme announcement and 
share your ideas with the College Night Reps!
          </p>
          <p class="paragraph-center sub">
              Historically, College Night started out as a formal dinner,
              usually held towards the end of each semester, including
              faculty and community associates. From the 1980s onward,
              they have been more casual, student-focused activities, with
              associates having little involvement.
          </p>
          <h3 class="h3" style={{ paddingTop: "50px" }}>Intramural (IM) Sports</h3>
          <div class="sub-hrule"></div>
          <div class="gallery">
            <img src="/images/about/powderpuff.jpeg" alt="Powderpuff" />
            <img src="/images/about/soccer.jpeg" alt="Soccer" />
          </div>
          <p class="paragraph-center sub">
               “Champions,” “Legendary,” “Undefeatable,” “Way sexier 
than all the other colleges.” As a Wiessmen, these are 
some phrases that are associated with Wiess’ incredible 
IM sports teams. IM sports are a way for Wiessmen 
to try a new sport, go back to a sport you love, get 
some excercise, or just cheer on your friends and fellow 
Wiessmen. They are a great, low-pressure way to get 
involved in Wiess culture, so help us pass on the tradition 
of Wiess’ IM sports dominance.
          </p>
          <p class="paragraph-center sub">
               One of these sports, known across campus as 
powderpuff, is the women’s flag football league, which 
is one of the most hotly contested sports leagues on 
campus. Historically called the "Battlesows," Wiess has won the championship more than any 
other college and we have the potential to add to that 
total every year. People all around Wiess get involved in 
the experience—from leading cheers on the sideline to 
organizing barbeques for supporters. No experience or 
“talent” is required to be on the team. Even if you don’t 
know what a touchdown is, Wiess powderpuff offers a 
great chance to hang out with your fellow Wiessmen 
and sport your goldenrod t-shirts (or even better, your 
Battlesows jersey).
          </p>
          <h3 class="h3" style={{ paddingTop: "50px" }}>Ubangee</h3>
          <div class="sub-hrule"></div>
          <div class="gallery">
            <img src="/images/about/ubangee.jpg" alt="Ubangee" />
            <img src="/images/about/ubangee2.jpg" alt="Ubangee" />
          </div>
          <p class="paragraph-center sub">
              A Ubangee is, first and foremost, an expression of love. 
The Ubangee combines the fun of tag with your friends 
with the simple joy of grunting. Every Ubangee has a 
“person of interest,” who lies in the center of a circle of 
jumping and yelling Wiessmen and one brace, protecting 
the person from physical harm. In some more, uh, 
rambunctious Ubangees, this “brace” might also serve 
to “tackle” the person who is being celebrated. After a 
satisfactory number of grunts have been emitted, the 
Ubangee ends with three triumphant, loud, and slow cries 
of TEAM WIESS.
          </p>
          <p class="paragraph-center sub">
There are numerous justifications for a Ubangee, ranging 
from a Wiessman having a birthday to celebrating an 
accomplishment. Ubangees are at their most prominent 
during the Beer Bike water balloon fight, as hordes of 
Wiessmen chase down anybody lucky enough to be 
picked as a Co-Fellow or unintelligent enough to target 
a Wiessman with a water balloon. They may sound 
frightening from this description, but don’t worry—they 
are magnificent and truly beautiful in practice.
          </p>
          <h3 class="h3" style={{ paddingTop: "50px" }}>Summit</h3>
          <div class="sub-hrule"></div>
          <div class="gallery">
            <img src="/images/about/summit.jpg" alt="Summit Group" />
            <img src="/images/about/summit2.jpg" alt="Summit" />
          </div>
          <p class="paragraph-center sub">
             In early fall, every Wiessman is invited to Summit, a day
long retreat at the beach (or on a boat depending on 
what era of Wiess history we are in). Summit is an 
awesome chance to soak up the sun and play in the sand 
while bonding with your new Wiess friends and getting 
to know the upperclassmen. It is also a great way for 
freshmen to have a voice in matters at the college and, 
most importantly, a great time.
          </p>
          <h3 class="h3" style={{ paddingTop: "50px" }}>Team Fun Friday Wiess (TFFW)</h3>
          <div class="sub-hrule"></div>
          <div class="gallery">
            <img src="/images/about/tffwcollegenight.jpg" alt="College Night TFFW" />
            <img src="/images/about/tffwwater.jpg" alt="Water TFFW" />
          </div>
          <p class="paragraph-center sub">
             It’s Friday! There is music playing the stacks. There are 
Wiessmen in the Acabowl playing volleyball and throwing 
around a frisbee. Maybe there's a petting zoo? Maybe the 
Core Team is grilling? Or maybe there’s a waterslide? 
Team Fun Friday Wiess happens a few times a month and 
each fun Friday has a theme and special fun activities that 
correspond with the theme. If you have great ideas for 
a TFFW, be sure to contact the TFFW Committee to get 
involved!
          </p>
          <h3 class="h3" style={{ paddingTop: "50px" }}>Wiess Skate</h3>
          <div class="sub-hrule"></div>
          <div class="gallery">
            <img src="/images/about/wiessskate.jpg" alt="Wiess Skate" />
            <img src="/images/about/wiessskate2.jpg" alt="Wiess Skate Group" />
          </div>
          <p class="paragraph-center sub">
             Once everyone returns from winter break, Wiess starts 
off the spring semester and the new year by carpooling 
to the ice skating rink in The Galleria. Whether you know 
how to ice skate or not, Wiess Skate is a time to enjoy 
the company of fellow Wiessmen, eat snacks, and take 
photos. If you are feeling competitive, join the annual 
inter-class race and show off your skating skills!
          </p>
          <h3 class="h3" style={{ paddingTop: "50px" }}>Pumpkin Caroling</h3>
          <div class="sub-hrule"></div>
          <div class="gallery">
            <img src="/images/about/pumpkincaroling.jpg" alt="Pumpkin Caroling" />
            <img src="/images/about/pumpkincaroling2.jpg" alt="Pumpkin Caroling" />
          </div>
          <p class="paragraph-center sub">
             Been wondering what to do on Halloween now that you 
are too old for Trick-or-Treating? Wiess has the answer: 
Pumpkin Caroling. Every Halloween, Wiess elects two 
College Idiots, one freshman and one upperclassman, who win the honor of rallying the college 
with an inspirational speech and serving as the Great 
Pumpkin. Then, with candles, song lyrics, and tasty 
fall treats in hand, we parade around campus singing 
caroling melodies with modified lyrics. The entire event 
is magnificent, but it gets even better when we visit 
Fondren.
          </p>
          <h3 class="h3" style={{ paddingTop: "50px" }}>Wiess' Finest</h3>
          <div class="sub-hrule"></div>
          <div class="gallery">
            <img src="/images/about/wiessfinest.jpg" alt="Wiess' Finest" />
            <img src="/images/about/wiessfinest2.jpg" alt="Wiess' Finest" />
          </div>
          <p class="paragraph-center sub">
             Every year Wiess hosts a talent show to select ‘Wiess’ 
Finest.’ This student-led competition allows nominated 
students to show off all different types of talents 
from renditions of popular artist’s songs, Just Dance 
performances, and even the legendary Fushigi. The 
winner goes on to represent Wiess at Rice’s finest.
          </p>
          <h3 class="h3" style={{ paddingTop: "50px" }}>Tabletop</h3>
          <div class="sub-hrule"></div>
          <div class="gallery">
            <img src="/images/about/tabletop.jpg" alt="Tabletop Rehearsal" />
            <img src="/images/about/tabletopstage.jpg" alt="Tabletop Stage" />
          </div>
          <p class="paragraph-center sub">
              Wiess’ very own theater company featuring many 
Wiessmen and non-Wiessmen, making its mark with 
amazing plays presented once a year such as “Hello 
Hamlet!” and “Company” that takes place in our very own 
Commons!!
          </p>
          <p class="paragraph-center sub">
              Originally, Wiess theater would perform their plays
              and musicals on top of the dining tables, hence the 
              name "Tabletop." In 1964, Wiessman George Greanias
              wrote the musical "Hello Hamlet!" spoofing Shakespeare
              and other musicals. The plot is naturally based off of
              Hamlet, taking elements from other Shakespearean tales
              as well. Since its inception, it has been performed
              every leap year, with alumni often turning out to
              come watch.
          </p>
          <h3 class="h3" style={{ paddingTop: "50px" }}>Freshmen Camping Trip</h3>
          <div class="sub-hrule"></div>
          <div class="gallery">
            <img src="/images/about/campingtrip.jpg" alt="Camping Trip" />
            <img src="/images/about/campingtrip2.jpg" alt="Camping Trip" />
          </div>
          <p class="paragraph-center sub">
              Every year, the sophomore representatives host a 
weekend-long camping trip in a near-by nature preserve 
for Wiess’ new students. New students will get to camp, 
swim, make s’mores, and explore in this tradition 
that many students consider their favorite during their 
time at Rice. New students can get involved with the new student council 
to help plan fun freshman events like the camping trip. Whether you’re a first-time camper or an 
experienced outdoorsmen, the freshmen camping trip is a 
great experience for everyone who goes. 
          </p>
          <h3 class="h3" style={{ paddingTop: "50px" }}>Proxy Cab</h3>
          <div class="sub-hrule"></div>
          <div class="gallery">
            <img src="/images/about/cab.jpg" alt="Cabinet" />
            <img src="/images/about/cab2.jpg" alt="Cabinet" />
          </div>
          <p class="paragraph-center sub" style={{ paddingBottom: "50px" }}>
              Every year, Wiessmen who are not members of Cabinet 
fill in for each official Cabinet member as “proxies.” These 
Wiessmen spend Proxy Cab debating on unique ways to 
spend a $100 and $500 prize. Past winners have included 
Project 1000, which involved all of Wiess attempting to 
eat 1000 chicken nuggets in one night, and the neon 
“Team Family Wiess” sign found in UpCo. Debate is 
always fiery, with each “proxy” bringing their idea to the 
table and Wiess Cabinet at large voting for the best, the 
funniest, or the most outlandish.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Traditions;